class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if( !this.classList.contains('collection_top_filter_info') ){
      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetButton = this.querySelector(".facets__open-button");
    if (facetButton) {
			facetButton.onclick = () => {
        this.querySelector(".facets__wrapper").classList.add("active");
        this.closest(".collection-wrapper")
				.querySelector(".products-grid__overlay")
				.classList.add("active");
			document.body.classList.add("overflow-hidden");
      }
    }

    if( this.closest(".collection-wrapper") ){
      const overlay = this.closest(".collection-wrapper").querySelector(".products-grid__overlay");
      if (overlay) 
      overlay.onclick = (event) => {
        event.currentTarget.closest(".collection-wrapper").querySelector(".facets__wrapper").classList.remove("active");
        event.currentTarget.classList.remove('active');
        document.body.classList.remove("overflow-hidden");
      }
    }

    const facetsClose = this.querySelector(".facets__close");
    if (facetsClose) {
      facetsClose.onclick = () => {
        this.querySelector(".facets__wrapper").classList.remove("active");
        this.closest(".collection-wrapper")
          .querySelector(".products-grid__overlay")
          .classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      };
    }

    const active_facets_el = document.querySelectorAll('.active-facets');
    active_facets_el.forEach((el)=>{
      const remove_facets_els = el.querySelectorAll('facet-remove.active-facets__button');
      remove_facets_els.length>0 && (
        el.querySelectorAll('facet-remove.active-facets__button')[remove_facets_els.length - 1].classList.add('last')
      );
    })
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {    
    let winPath = window.location.pathname;
    let type = ''
    if( document.querySelector('.search-result.search-performed') ){
      winPath = '/search';
      type = '&type=product'
    }    
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${winPath}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url+type, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) {
      loadMore();
    }

    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML || '0 results';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.querySelector('.mobile-facets__count');
    container && (
      container.innerHTML = count,
      container.classList.remove('loading')
    );
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
    }

    // Parse the numeric count and show/hide the zero-results warning
    const countText = container ? container.textContent : '';
    const countNum = parseInt(countText.replace(/[^0-9]/g, ''), 10);
    FacetFiltersForm.toggleZeroResultsWarning(isNaN(countNum) ? false : countNum === 0);
  }

  static toggleZeroResultsWarning(show) {
    const WARNING_ID = 'facets-zero-results-warning';
    const bottom = document.querySelector('.facets__wrapper-bottom');
    if (!bottom) return;

    let warning = document.getElementById(WARNING_ID);

    if (show) {
      if (!warning) {
        warning = document.createElement('p');
        warning.id = WARNING_ID;
        warning.textContent = 'No results. Adjust your selection.';
        warning.style.cssText = [
          'margin: 0 auto 0 0',
          'padding: 0 20px',
          'height: 56px',
          'background: #FBCB00',
          'border: none',
          'border-radius: 999px',
          'font-size: 13px',
          'color: rgb(var(--color-foreground))',
          'line-height: 1',
          'text-align: left',
          'display: inline-flex',
          'align-items: center',
          'flex-shrink: 0'
        ].join(';');
        bottom.insertBefore(warning, bottom.firstChild);
      }
    } else {
      if (warning) warning.remove();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const el_html = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if( el_html ){
        el_html.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__open-button")) {
        document.querySelector(".facets__open-button").classList.add('facets__open-button_accent');
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__open-button")) {
        document.querySelector(".facets__open-button").classList.remove('facets__open-button_accent');
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--tertiary")) {
        document.querySelector(".facets__wrapper-bottom .button--tertiary").removeAttribute('disabled');
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--tertiary")) {
        document.querySelector(".facets__wrapper-bottom .button--tertiary").setAttribute('disabled', '');
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.removeAttribute('disabled');
        })
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.setAttribute('disabled', '');
        })
      }

      const p_ele_custom = activeFacetsElement.closest('facet-filters-form');
      if( p_ele_custom && p_ele_custom.classList.contains('collection_top_filter_info') ){
        if( !p_ele_custom.classList.contains('no-facets_active') ){
          document.querySelector(selector).closest('facet-filters-form')?.classList.remove('no-facets_active');
        }else{
          document.querySelector(selector).closest('facet-filters-form')?.classList.add('no-facets_active');
        }
      }
    })   
    
    const active_facets_el = document.querySelectorAll('.active-facets');
    active_facets_el.forEach((el)=>{
      const remove_facets_els = el.querySelectorAll('facet-remove.active-facets__button');
      remove_facets_els.length>0 && (
        el.querySelectorAll('facet-remove.active-facets__button')[remove_facets_els.length - 1].classList.add('last')
      );
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      if( document.querySelector(selector) ){
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    if( event.target.closest('.custom-cms-banner-section') ) return;
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if( event.target.closest('.custom-cms-banner-section') ) return;
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      searchParams = this.returnSearchParam(searchParams);
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      var check_data_URL = forms.join('&')
      check_data_URL = this.returnSearchParam(check_data_URL);
      this.onSubmitForm(check_data_URL, event)
    }
  }

  returnSearchParam(queryString){    
    if (queryString.includes('%2C')) {      
      const queryParts = queryString.split('&');
      const updatedParts = queryParts.map(part => {        
        if (part.includes('dimensions') && part.includes('%2C')) {
          let [key, val] = part.split('=');          
          const cleanVal = val.replaceAll('%2C',',');
          return `${key}=${cleanVal}`;
        }
        return part;
      });      
      return updatedParts.join('&');      
    }else{
      return queryString;
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();    
    this.controlSlider();
    if(this.tagName == 'PRICE-RANGE'){
      this.controlTextInputs();
    }
    this.setInputWidth();    
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    if(this.tagName == 'CUSTOM-FILTER-RANGE'){     
      return;
    }
    const inputs = this.querySelectorAll('input.field__input:not(.hidden_input)'); 
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    // FIX 4: Inject focus-ring and cursor styles once per page for the
    // dimension filter number inputs. Uses theme CSS vars so it matches
    // the rest of the UI automatically.
    if (!document.getElementById('custom-filter-range-styles')) {
      const style = document.createElement('style');
      style.id = 'custom-filter-range-styles';
      style.textContent = `
        custom-filter-range .field-wrapper .field__input:not(.field__input-hidden) {
          cursor: text;
          background: transparent;
          border-bottom: 1px solid rgb(var(--color-border));
          padding-bottom: 1px;
        }
        custom-filter-range .field-wrapper .field__input:not(.field__input-hidden):focus {
          outline: 1px solid rgb(var(--color-border));
          outline-offset: 8px;
          border-radius: 888px;
          border-bottom: none;
          padding-bottom: 1px;
        }
      `;
      document.head.appendChild(style);
    }

    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('input.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('input.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if(this.tagName == 'CUSTOM-FILTER-RANGE'){
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = Math.ceil(this.sliderToValue(to));
          } else {
            inputNumberFrom.value = Math.ceil(this.sliderToValue(from));
          }
        }else {
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = to;
          } else {
            inputNumberFrom.value = from;
          }
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if(this.tagName == 'CUSTOM-FILTER-RANGE'){
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = Math.ceil(this.sliderToValue(to));
          } else {
            inputNumberTo.value = Math.ceil(this.sliderToValue(from));
            inputRangeTo.value = from;
          }
        }else {
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = to;
          } else {
            inputNumberTo.value = from;
            inputRangeTo.value = from;
          }
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlTextInputs() {
    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('input.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      if (this.tagName == 'CUSTOM-FILTER-RANGE') {

        // Move the slider to reflect the typed value, but leave the number
        // display exactly as the user typed it -- no snapping the text.
        const snapFrom = () => {
          const raw = parseFloat(inputNumberFrom.value);
          if (isNaN(raw)) return;
          // Slider moves to nearest catalog position visually
          inputRangeFrom.value = this.valueToSlider(raw);
          this.fillSlider();
        };

        const snapTo = () => {
          const raw = parseFloat(inputNumberTo.value);
          if (isNaN(raw)) return;
          inputRangeTo.value = this.valueToSlider(raw);
          this.fillSlider();
        };

        // Debounced submit helpers
        let _fromTimer, _toTimer;
        const submitFrom = () => {
          snapFrom();
          this.onRangeChange({ currentTarget: inputRangeFrom });
        };
        const submitTo = () => {
          snapTo();
          this.onRangeChange({ currentTarget: inputRangeTo });
        };

        // Live slider update while typing, submit after 600ms pause
        inputNumberFrom.oninput = () => {
          clearTimeout(_fromTimer);
          const v = parseFloat(inputNumberFrom.value);
          if (!isNaN(v)) { inputRangeFrom.value = this.valueToSlider(v); this.fillSlider(); }
          _fromTimer = setTimeout(submitFrom, 600);
        };

        inputNumberTo.oninput = () => {
          clearTimeout(_toTimer);
          const v = parseFloat(inputNumberTo.value);
          if (!isNaN(v)) { inputRangeTo.value = this.valueToSlider(v); this.fillSlider(); }
          _toTimer = setTimeout(submitTo, 600);
        };

        // Enter: submit immediately
        inputNumberFrom.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); clearTimeout(_fromTimer); submitFrom(); }
        });
        inputNumberTo.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); clearTimeout(_toTimer); submitTo(); }
        });

        // Blur: submit if anything was typed; restore previous value if empty
        inputNumberFrom.addEventListener('blur', () => {
          clearTimeout(_fromTimer);
          if (inputNumberFrom.value === '') {
            // Nothing typed -- restore the pre-focus value
            inputNumberFrom.value = inputNumberFrom.dataset.prefocus || Math.ceil(this.sliderToValue(parseInt(inputRangeFrom.value, 10)));
            snapFrom();
          } else {
            submitFrom();
          }
        });
        inputNumberTo.addEventListener('blur', () => {
          clearTimeout(_toTimer);
          if (inputNumberTo.value === '') {
            inputNumberTo.value = inputNumberTo.dataset.prefocus || Math.ceil(this.sliderToValue(parseInt(inputRangeTo.value, 10)));
            snapTo();
          } else {
            submitTo();
          }
        });

        // Focus + mousedown: clear the field so the user types fresh.
        // mousedown fires before focus on a click, and on type="number" the
        // browser can visually restore the value between the two events.
        // Clearing on both events ensures the field is empty when the user
        // starts typing regardless of whether they clicked or tabbed in.
        const clearInput = (inp) => {
          if (inp.dataset.prefocus === undefined || inp.dataset.prefocus === '') {
            inp.dataset.prefocus = inp.value;
          }
          inp.value = '';
        };
        inputNumberFrom.addEventListener('focus', () => clearInput(inputNumberFrom));
        inputNumberFrom.addEventListener('mousedown', (e) => {
          // Only clear on mousedown if not already focused
          if (document.activeElement !== inputNumberFrom) {
            clearInput(inputNumberFrom);
          }
        });
        inputNumberTo.addEventListener('focus', () => clearInput(inputNumberTo));
        inputNumberTo.addEventListener('mousedown', (e) => {
          if (document.activeElement !== inputNumberTo) {
            clearInput(inputNumberTo);
          }
        });

        // Restore saved value if user focused but typed nothing (empty on blur)
        // -- handled above in the blur listeners via the empty-string check.

      } else {
        // Standard price range: original oninput behaviour unchanged.
        inputNumberFrom.oninput = () => {
          const from = parseInt(inputNumberFrom.value, 10);
          const to = parseInt(inputNumberTo.value, 10);
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = to;
          } else {
            inputRangeFrom.value = from;
          }
          this.fillSlider();
          this.setInputWidth();
        };

        inputNumberTo.oninput = () => {
          const from = parseInt(inputNumberFrom.value, 10);
          const to = parseInt(inputNumberTo.value, 10);
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = to;
          } else {
            inputNumberTo.value = from;
          }
          this.fillSlider();
        };
      }

    })
  }

  setInputWidth() {    
    const field_wrapper = document.querySelectorAll('price-range .facets__price-wrapper .field-wrapper');    
    field_wrapper.forEach((field_ele)=>{
      const value = field_ele.querySelector('input.field__input').value,
      hidden_ele = field_ele.querySelector('.field__input-hidden');
      let width = 0; 
      if( hidden_ele ){
        value != '' && hidden_ele && ( field_ele.querySelector('.field__input-hidden').textContent = value);
        width = field_ele.querySelector('.field__input-hidden').offsetWidth
      }
      field_ele.querySelector('input.field__input').style.minWidth = '';
      width > 33 && (field_ele.querySelector('input.field__input').style.minWidth = width +'px');
      if( field_ele.querySelector('.field__currency') ){
        field_ele.querySelector('.field__currency').classList.remove('no-value');
        value == '' && ( field_ele.querySelector('.field__currency').classList.add('no-value'));
      }
    })
  }

  nearestIndex(arr, value) {
    const found_index = arr.indexOf(value);    
    if( found_index > -1 ){
      return found_index;
    }else{
      return arr.reduce((closestIdx, curr, idx) =>
        Math.abs(curr - value) < Math.abs(arr[closestIdx] - value) ? idx : closestIdx
      , 0);
    }
  }

  // -------------------------------------------------------------------------
  // Value-proportional slider helpers (used by CustomFilterRange only).
  //
  // The slider element runs on a 0-1000 integer scale. These two methods
  // translate between that scale and real-world inch values, using linear
  // interpolation across the full allowed range. This means the slider thumb
  // position is physically proportional to the measurement, not the catalog
  // entry count.
  // -------------------------------------------------------------------------
  valueToSlider(value) {
    if (!this.allowed || this.allowed.length < 2) return 0;
    const minVal = this.allowed[0];
    const maxVal = this.allowed[this.allowed.length - 1];
    if (maxVal === minVal) return 0;
    return Math.round(((value - minVal) / (maxVal - minVal)) * 1000);
  }

  sliderToValue(pos) {
    if (!this.allowed || this.allowed.length < 2) return 0;
    const minVal = this.allowed[0];
    const maxVal = this.allowed[this.allowed.length - 1];
    const rawValue = minVal + (pos / 1000) * (maxVal - minVal);
    // Snap to nearest allowed catalog value
    return this.allowed.reduce((closest, curr) =>
      Math.abs(curr - rawValue) < Math.abs(closest - rawValue) ? curr : closest
    );
  }
}

customElements.define('price-range', PriceRange);

class CustomFilterRange extends PriceRange {  
  constructor() {
    super();

    // Re-bind change listeners (super() binds them too, but we need our overridden onRangeChange)
    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    // Build the sorted array of allowed real-world dimension values from the data-values attribute
    this.allowed = (this.querySelector('.facets__custom-range-wrapper').dataset.values || '')
    .replace(/^\[/,'').replace(/\]$/,'')
    .split(',')
    .map(function(s) { return Number(s.trim()); })
    .filter(function(n) { return !isNaN(n); })
    .sort(function(a,b){return a-b;});

    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('input.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('input.field__input')[1];

      // -----------------------------------------------------------------------
      // FIX 3: Value-proportional slider scale.
      //
      // The Liquid template renders range inputs with max = number of catalog
      // entries (e.g. 99 for 100 distinct heights). We override both min and max
      // to a fixed 0-1000 scale so slider position is proportional to the real
      // inch value, not the catalog entry count. The valueToSlider() /
      // sliderToValue() helpers handle the conversion.
      // -----------------------------------------------------------------------
      inputRangeFrom.min = 0;
      inputRangeFrom.max = 1000;
      inputRangeTo.min = 0;
      inputRangeTo.max = 1000;

      // Determine starting inch values: prefer URL params, fall back to
      // the number inputs rendered by Liquid.
      let startMin = parseFloat(inputNumberFrom.value) || this.allowed[0];
      let startMax = parseFloat(inputNumberTo.value) || this.allowed[this.allowed.length - 1];

      // FIX 1: Restore slider position from the current URL after a re-render.
      const paramName = this.dataset.name;
      if (paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        const activeValues = urlParams.get(paramName);
        if (activeValues && this.allowed.length > 0) {
          const parts = activeValues.split(',').map(Number).filter(n => !isNaN(n)).sort((a,b) => a-b);
          if (parts.length > 0) {
            startMin = parts[0];
            startMax = parts[parts.length - 1];
          }
        }
      }

      // Snap inch values to nearest allowed, then convert to 0-1000 slider positions
      const snappedMin = this.allowed.reduce((c, v) => Math.abs(v - startMin) < Math.abs(c - startMin) ? v : c);
      const snappedMax = this.allowed.reduce((c, v) => Math.abs(v - startMax) < Math.abs(c - startMax) ? v : c);

      inputRangeFrom.value = this.valueToSlider(snappedMin);
      inputRangeTo.value   = this.valueToSlider(snappedMax);
      inputNumberFrom.value = Math.ceil(snappedMin);
      inputNumberTo.value   = Math.ceil(snappedMax);

      this.fillSlider();
    });

    // Now that this.allowed is built and tagName is correct, wire up the
    // text input handlers (focus-clear, debounced submit, blur-snap, Enter).
    this.controlTextInputs();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setValue(event.currentTarget);
    this.setMinAndMaxValues();
    this.controlInput(event);
  }

  setValue(input) {
    this.fillSlider();
  }

  controlInput(event) {
    if(this.allowed == undefined || this.allowed.length == 0) return;

    var minSlider = this.querySelector('.lengthMin');
    var maxSlider = this.querySelector('.lengthMax');
    var paramName = this.dataset.name;

    var iMin = Number(minSlider.value);
    var iMax = Number(maxSlider.value);

    // -----------------------------------------------------------------------
    // FIX 2: Prevent mid-drag re-renders ("drunk slider" behavior).
    //
    // The original code called onSubmitHandler immediately (inside a 150ms
    // setTimeout) on every oninput event. The browser fires oninput
    // continuously while the user is dragging, so each tick triggered a full
    // page fetch + DOM rebuild that re-initialized this component under the
    // user's hand, causing the slider to reset or jump.
    //
    // The fix has two parts:
    //   a) We only reach this method via onRangeChange, which is bound to the
    //      'change' event (fires ONCE when the user releases the slider),
    //      not 'input' (fires on every pixel of movement). The controlSlider()
    //      oninput handlers in PriceRange still update the number display
    //      live while dragging -- that visual feedback is preserved.
    //   b) We debounce the actual submit call so rapid successive changes
    //      (e.g. typing in the text input) still coalesce into one request.
    // -----------------------------------------------------------------------
    if (this._submitTimer) clearTimeout(this._submitTimer);
    this._submitTimer = setTimeout(() => {
      // Convert 0-1000 slider positions back to real inch values, snap to
      // nearest allowed, then slice the full allowed array between them.
      const minVal = this.sliderToValue(iMin);
      const maxVal = this.sliderToValue(iMax);
      const minIdx = this.nearestIndex(this.allowed, minVal);
      const maxIdx = this.nearestIndex(this.allowed, maxVal);
      var chosen = this.allowed.slice(Math.min(minIdx, maxIdx), Math.max(minIdx, maxIdx) + 1);

      var url = new URL(window.location.href);
      url.searchParams.delete(paramName);

      this.querySelector(`input.hidden_input[name="${paramName}"]`).value = chosen.join(',');

      this.closest('facet-filters-form').onSubmitHandler(event);
    }, 150);
  }
}
customElements.define('custom-filter-range', CustomFilterRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    if( this.closest('.custom-cms-banner-section') ){
      this.closest('facet-filters-form').querySelectorAll('form').forEach(( form_el )=> form_el.reset());
      this.closest('facet-filters-form').querySelectorAll('custom-filter-range').forEach(( form_el )=>{
        form_el.fillSlider()
        form_el.querySelector('.hidden_input').value = ''
      })
    }else{
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);



class customDropdown extends HTMLElement {
  constructor() {
    super();   
    const dropdown = this;     
    this.querySelector('.fa--cu-dd__label') && (
      this.querySelector('.fa--cu-dd__label').addEventListener('click', function(){      
        if( dropdown.classList.contains('active') ){
          dropdown.classList.remove('active');
        }else{
          dropdown.classList.add('active');
        }        
      })
    )

    this.querySelector('.mob-fas__soby-custom--ul') && (
      this.querySelectorAll('.mob-fas__soby-custom--ul li').forEach(( li_ele )=>{
        li_ele.addEventListener('click', function(){
          dropdown.classList.remove('active');
          document.querySelector('input[name="sort_by"]').value = this.dataset.value;
          document.querySelector('input[name="sort_by"]').closest('facet-filters-form').onSubmitHandler();
        })
      })
    );

    this.querySelectorAll('.list-menu__item').length && (
      this.querySelectorAll('.list-menu__item').forEach(( list_ele )=>{
        list_ele.addEventListener('click', function(){
          dropdown.classList.remove('active');
          dropdown.querySelector('.fa--cu-dd__selected-value').innerHTML = list_ele.querySelector('.facet-checkbox__label').innerText.trim();
          dropdown.querySelector('.fa--cu-dd__label').classList.add('facet_selected')
        })
      })      
    )
    
    this.querySelector('div.facets-sorting__label') && (      
      this.querySelector('div.facets-sorting__label').addEventListener('click', function(){      
        if( dropdown.classList.contains('active') ){
          dropdown.classList.remove('active');
        }else{
          dropdown.classList.add('active');
        }        
      }),
      this.querySelectorAll('.select__radio label').forEach(( lable_ele )=>{
        lable_ele.addEventListener('click', function(){       
          if(dropdown.querySelector('.select__radio label input:checked')){
            dropdown.querySelector('.select__radio label input:checked').checked = false;
          }
          document.querySelectorAll('[name="sort_by"]').forEach((select)=>{
            if ( dropdown.querySelector('select[name="sort_by"]') != select ){
              select.value = lable_ele.querySelector('input').value;
            }
          })
          lable_ele.querySelector('input').checked = true;
          dropdown.querySelector('select[name="sort_by"]').value = lable_ele.querySelector('input').value;
          dropdown.querySelector('select[name="sort_by"]').dispatchEvent(new Event('input', { bubbles: true }))
        })
      }),
      document.addEventListener('click', (e) =>{
        const target = e.target
        if( document.querySelectorAll('custom-dropdown.active').length > 0 ){
          if( target.closest('.facets-sorting__label') != null || target.classList.contains('facets-sorting__label') ){
            return;
          }
          document.querySelectorAll('custom-dropdown.active').forEach((ele)=> ele.classList.remove('active'));        
        }
      })
    );
  }
}
customElements.define('custom-dropdown', customDropdown);